import FirstImage from "../../assets/aboutUs/firstImage.png";
import SecondImage from "../../assets/aboutUs/secondImage.png";
import styles from "./styles.module.scss";

const FirstBlock = () => {
  return (
    <>
      <section className={styles.hero} aria-labelledby="about-title">
        <div className={styles.heroInner}>
          <div className={styles.heroCopy}>
            <p className={styles.eyebrow}>About Train GRC</p>
            <h1 id="about-title">
              Hands-On Skills{" "}
              <span>For Real-World Problems.</span>
            </h1>
            <p className={styles.heroLead}>
              While the cloud enables innovation and technological capacities
              companies couldn’t have dreamed of a decade ago, those
              technologies are not magic boxes that run without configuration or
              maintenance.
            </p>
            <ul className={styles.heroProof} aria-label="Our training approach">
              <li>Learn from first principles</li>
              <li>Practice with real services</li>
              <li>Apply skills on the job</li>
            </ul>
          </div>

          <figure className={styles.heroVisual}>
            <img
              src={FirstImage}
              alt="Hands working on a laptop during a technical training session"
              width="2680"
              height="1964"
            />
            <figcaption>
              <strong>Technical depth.</strong>
              <span>Practical context. Clear instruction.</span>
            </figcaption>
          </figure>
        </div>
      </section>

      <section className={styles.foundations} aria-labelledby="approach-title">
        <div className={styles.foundationsInner}>
          <header className={styles.sectionHeading}>
            <p className={styles.eyebrow}>How we teach</p>
            <h2 id="approach-title">
              Cloud auditing starts with the system—not the checklist.
            </h2>
          </header>

          <div className={styles.assuranceRow}>
            <article className={styles.assuranceCard}>
              <span className={styles.cardNumber} aria-hidden="true">
                01
              </span>
              <h3>Build meaningful assurance.</h3>
              <p>
                The process of building and managing cloud technologies must be
                governed, regardless of the promises offered by automated
                solutions. To provide meaningful assurance, organizations must
                assess staffing, processes, and technologies to ensure
                operational, financial, and security objectives are met. Train
                GRC can help break through the complexity to provide a clear
                understanding of security assessment tools and techniques that
                can be used to inform these efforts.
              </p>
            </article>

            <figure className={styles.labVisual}>
              <img
                src={SecondImage}
                alt="Close view of a laptop keyboard used for a hands-on technical lab"
                width="2688"
                height="2160"
                loading="lazy"
              />
              <figcaption>See the technology. Understand the system.</figcaption>
            </figure>
          </div>

          <article className={styles.principlesCard}>
            <div className={styles.principlesIntro}>
              <span className={styles.cardNumber} aria-hidden="true">
                02
              </span>
              <p className={styles.darkEyebrow}>First-principles instruction</p>
              <h3>
                We Teach Cloud Auditing
                <span>From First Principles.</span>
              </h3>
            </div>
            <div className={styles.principlesCopy}>
              <p>
                Even companies that use identical technologies may be using the
                technologies in very divergent ways. In fact, it’s the
                integration of various technologies into unified capabilities
                that allows organizations to achieve powerful business outcomes
                while simultaneously increasing overall attack surfaces. Due to
                typical technology vendor sprawl, the notion that tools are
                coming to “ensure” or “prove” security in a comprehensive manner
                seems unlikely.
              </p>
              <p>
                For these reasons, we teach cloud auditing from first principles,
                starting with an understanding of the capabilities and threats
                that are relevant to cloud environments. Using these principles
                as the foundation for our assessments, we help our GRC
                professionals gain hands-on, technical skills with the services
                used by engineering teams, providing you the skills to meet
                on-going or newly identified security and compliance obligations.
              </p>
            </div>
          </article>
        </div>
      </section>
    </>
  );
};

export default FirstBlock;
